// extracted by mini-css-extract-plugin
export default {"container":"ApiUserWarningLayout_container__GMPwP","content":"ApiUserWarningLayout_content__gCnQk"};